// Lista centralizada das naturezas de processo para reutilização no app
// Mantém a grafia padronizada para exibição e persistência

export const PROCESS_NATURES = [
  'Criminal',
  'Trabalhista',
  'Tributária',
  'Previdenciária',
  'Civil',
  'Sucessões',
  'Administração Pública',
  'Administrativo',
]

export default PROCESS_NATURES
